import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
`;

export const Title = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 20px;
  font-weight: 600;
`;

export const SubTitle = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 14px;
  font-weight: 300;
`;
